<template>
  <v-container>
    <v-btn fixed dark fab bottom right color="pink" @click="createNew">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-data-table :items="counters" :headers="headers" :loading="isBusy"
                  @click:row="editSelected" disable-pagination hide-default-footer
                  fixed-header disable-sort class="row-pointer">
      <template v-slot:item.type="{ item }">
        <span>{{ typeToStr(item.type) }}</span>
      </template>
      <template v-slot:item.isActive="{ item }">
        <v-icon>{{ item.isActive === true ? "mdi-checkbox-marked-outline" : "mdi-checkbox-blank-outline" }}</v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>

export default {
  name: 'Values',
  data() {
    return {
      isBusy: false,
      headers: [
        {value: 'title', text: 'Название'},
        {value: 'type', text: 'Тип'},
        {value: 'number', text: 'Номер'},
        {value: 'isActive', text: 'Активный', align: 'center'},
      ],
      values: []
    }
  },
  mounted() {
    this.isBusy = true
    this.$http("/value")
        .then(resp => this.values = resp.data)
        .finally(() => this.isBusy = false)
  },
  methods: {
    typeToStr: function (type) {
      const result = {
        "WATER_HOT": "Горячая вода",
        "WATER_COLD": "Холодная вода",
        "ELECTRO_1": "Электричество (1 тариф)",
        "ELECTRO_2": "Электричество (2 тарифа)",
        "ELECTRO_3": "Электричество (3 тарифа)",
      }[type]
      return result ? result : type
    },
    createNew: function () {
      this.$router.push({name: 'CounterEdit', params: {counterId: null}})
    },
    editSelected: function (item) {
      this.$router.push({name: 'CounterEdit', params: {counterId: item.id}})
    }
  }
}

</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>